import { Component, output, input, inject, OnInit } from '@angular/core';
import { translation } from '@cue/translations';
import { AssistPropertyBM, LocalizedString, ResourceAssignType } from '@cue/api';
import { NavigationDetailInfo } from '@cue/navigation-services';
import { AddinConfigService } from '@outlook-addin/shared';
import {
  cueAction,
  cueArrowRight,
  cueClose,
  cueExternalLink,
  cueRefresh,
  cueCheck,
  IconComponent,
} from '@cue/ui/icons';
import { LoadingComponent } from '@cue/loading';
import { TranslocoPipe } from '@jsverse/transloco';
import { AssignToPipe, AssignToTranslateKeyToPipe, ResourceExternalUrlPipe } from '../shared/pipes';
import { ImageWidthPipe, LocalizedStringPipe } from '@cue/utilities';
import { ResourceMapComponent } from '../reservation/resource-map/resource-map.component';
import { CustomUnsafeSanitizePipe } from '@cue/security';
import { WorkingHoursComponent } from '@cue/ui';
import { FileGalleryComponent } from '@cue/ui/file-gallery';
import { Pack } from '@cue/data';
import { NgStyle } from '@angular/common';
import { CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';
import {
  getNavigationResourcePropertyValue,
  hasVisibleResourcePropertyValue,
} from '../shared/utils/resource-property.utils';

@Component({
  selector: 'addin-resource-summary-detail',
  templateUrl: './resource-summary-detail.component.html',
  styleUrls: ['./resource-summary-detail.component.scss'],
  imports: [
    LoadingComponent,
    IconComponent,
    TranslocoPipe,
    AssignToTranslateKeyToPipe,
    AssignToPipe,
    ResourceExternalUrlPipe,
    ImageWidthPipe,
    ResourceMapComponent,
    LocalizedStringPipe,
    CustomUnsafeSanitizePipe,
    WorkingHoursComponent,
    FileGalleryComponent,
    NgStyle,
    CdkConnectedOverlay,
  ],
})
export class ResourceSummaryDetailComponent implements OnInit {
  overlay = inject(Overlay);
  globalOverlay = this.overlay.position().global().centerHorizontally() as any;

  private configService = inject(AddinConfigService);

  ICONS = {
    cueClose,
    cueArrowRight,
    cueAction,
    cueRefresh,
    cueExternalLink,
    cueCheck,
  };

  resourceAssignType = ResourceAssignType;
  translation = translation;
  currentImage = undefined;

  protected canShowLinkToAssist: boolean;
  isResourceSelected = input<boolean>();
  resourceDetail = input<Pack<NavigationDetailInfo>>();
  isLoading = input<boolean>();
  eventStart = input<any>();
  eventEnd = input<any>();

  refresh = output<void>();
  selectDeselectResource = output<number>();
  closeResourceDetail = output<void>();
  apiUrl: string;

  constructor() {}

  getSimpleFiltersByResourceTypeId(detail?: NavigationDetailInfo) {
    return this.getFiltersFromNavigationDetail(detail).filter(
      (property) =>
        property.dataTypeId !== 5 && hasVisibleResourcePropertyValue(property.visible, property.value?.value)
    );
  }

  getEnumerableFiltersByResourceTypeId(detail?: NavigationDetailInfo) {
    return this.getFiltersFromNavigationDetail(detail).filter(
      (property) => property.dataTypeId === 5 && hasVisibleResourcePropertyValue(property.visible, property.value)
    );
  }

  private getFiltersFromNavigationDetail(
    detail?: NavigationDetailInfo
  ): { name: LocalizedString; value: any; dataTypeId: number; visible: boolean }[] {
    return (detail?.properties ?? []).map((property) => ({
      name: property.name,
      dataTypeId: property.propertyTypeId,
      value: this.getValueFromProperty(property),
      visible: property.visible,
    }));
  }

  getValueFromProperty(property: AssistPropertyBM & { propertyTypeId: number; valueChoices: any[] }) {
    return getNavigationResourcePropertyValue(property);
  }

  navigateToResourceDetailInAssist(url: string) {
    window.open(url, '_blank');
  }

  ngOnInit(): void {
    this.apiUrl = this.configService.value.apiURL;
    this.canShowLinkToAssist = !this.configService.value.configuration.isCAFromAddin;
  }
}
